<div class="sign-in-shell">
  <!-- Sports-themed decorative layers -->
  <div class="sign-in-pitch"></div>
  <div class="sign-in-streak sign-in-streak-1"></div>
  <div class="sign-in-streak sign-in-streak-2"></div>
  <div class="sign-in-glow sign-in-glow-top"></div>
  <div class="sign-in-glow sign-in-glow-bottom"></div>

  @if (isLoggingIn()) {
    <div class="loading-indicator">
      <mat-progress-spinner
        color="primary"
        mode="indeterminate">
      </mat-progress-spinner>
    </div>
  }

  <section class="sign-in-content">
    <header class="sign-in-header">
      <img class="sign-in-logo" [src]="_globals.theme === 'dark' ? '/assets/logos/ds_liggande_vit.svg' : '/assets/logos/ds_liggande_svart.svg'" alt="Dalecarlia Scouting Logo" />
      <h1 class="sign-in-title">Scout</h1>
      <!-- <p class="sign-in-subtitle">Dalecarlia Scouting Platform</p> -->
    </header>

    <div class="sign-in-card">
      <form #loginForm="ngForm" class="sign-in-form" (ngSubmit)="OnSubmit(UserName.value, Password.value)">
        <mat-form-field appearance="outline" class="sign-in-field">
          <mat-label>{{'LOGIN.ENTERUSERNAME' | translate}}</mat-label>
          <input matInput type="text" #UserName ngModel name="UserName" placeholder="{{'LOGIN.USERNAME' | translate}}" required [disabled]="isLoggingIn()">
          <mat-icon matSuffix>account_box</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="sign-in-field">
          <mat-label>{{'LOGIN.ENTERPASSWORD' | translate}}</mat-label>
          <input matInput type="password" #Password ngModel name="Password" placeholder="{{'LOGIN.PASSWORD' | translate}}" required [disabled]="isLoggingIn()">
          <mat-icon matSuffix>vpn_key</mat-icon>
        </mat-form-field>

        @if (isLoginError()) {
          <div class="login-error-banner">
            <mat-icon>error_outline</mat-icon>
            <span>{{'LOGIN.INCORRECTUSERNAMEPASSWORD' | translate}}</span>
          </div>
        }

        <button mat-flat-button color="primary" [disabled]="isLoggingIn()" type="submit" class="sign-in-submit">
          {{'GENERAL.LOGIN' | translate | uppercase}}
        </button>

      <!--   <a mat-button [disabled]="isLoggingIn()" type="button" routerLink="/resetpassword" class="recover-link">
          {{'LOGIN.RECOVERPASSWORD' | translate}}
        </a> -->
      </form>
    </div>

    <div class="build-version">2026-10-09</div>
  </section>
</div>
